﻿import React, { useEffect, useRef, useState } from "react";
import {
  Alert,
  Stack,
  ListItem,
  ListItemText,
  Button,
  FormControl,
  Select,
  MenuItem,
  TextField,
  InputAdornment,
  Modal,
  Box,
  Typography,
  IconButton,
  Card,
  List,
  Chip,
  Avatar,
  Divider,
  CircularProgress,
  Paper,
  Fade
} from "@mui/material";
import SearchField from "./SearchField";
import { Postrequestcall } from "../../request/Postrequest";
import {
  FETCH_COMPANIES_BY_NAME,
  FETCH_COMPANIES_PRODUCTS,
  FETCH_PRODUCTS,
  FETCH_PROJECT_SITE_PRODUCTS,
  FETCH_PROJECTS_PRODUCTS,
  FETCH_TRADE_PRODUCTS,
  SAVE_COMPANIES,
  SAVE_PRODUCTS
} from "../../constant/Apipath";
import { useSelector } from "react-redux";
import Loader from "../../common/Loader";
import { Search as SearchIcon, Business as BusinessIcon, Add as AddIcon, Visibility as ViewIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { English } from "../../constant/EnglishFallback";
import { useDispatch } from "react-redux";
import { setShowalert } from "../../redux/actions/actions";

const AddProductModal = ({
  open,
  onClose,
  from,
  mainId,
  saveProduct,
  manufactureDetails,
  title,
  currentCompanyName = "",
  currentCompanyAllowPublicProductSubmission = true,
  showCurrentManufacturerAction = true,
  lockManufacturerToCurrent = false,
  skipManufacturerPrefill = false,
  skipCompanyProductSave = false,
  onProductCreated,
  initialProductName = "",
  initialManufacturerName = "",
  initialProductType = ""
}) => {
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const currentUserId = loginData?.userInformation?.UserId ?? 0;

  const debounceTimeout = useRef(null);
  const manufacturerDebounceTimeout = useRef(null);
  const manufacturerPageSize = 20;
  const [isLoading, setIsLoading] = useState(false);
  const [showSubmitLoading, setShowSubmitLoading] = useState(false);
  const [addingProductId, setAddingProductId] = useState(null);

  const [productData, setProductData] = useState([]);
  const [productSearchTerm, setProductSearchTerm] = useState("");
  const [manufacturerSearchTerm, setManufacturerSearchTerm] = useState("");

  // Manufacturer suggestions state
  const [manufacturerSuggestions, setManufacturerSuggestions] = useState([]);
  const [showManufacturerSuggestions, setShowManufacturerSuggestions] = useState(false);
  const [selectedManufacturer, setSelectedManufacturer] = useState(null);
  const [manufacturerSearchLoading, setManufacturerSearchLoading] = useState(false);
  const [manufacturerPageNumber, setManufacturerPageNumber] = useState(1);
  const [manufacturerHasMore, setManufacturerHasMore] = useState(true);
  const [manufacturerPageLoading, setManufacturerPageLoading] = useState(false);

  const [productType, setProductType] = useState("");

  const {
    TEXT_PRODUCT_NAME = English?.AddProductModal?.TEXT_PRODUCT_NAME,
    TEXT_MANUFRACTURER_OPTIONAL = English?.AddProductModal?.TEXT_MANUFRACTURER_OPTIONAL,
    TEXT_TYPE = English?.AddProductModal?.TEXT_TYPE,
    TEXT_NEW_PRODUCT = English?.AddProductModal?.TEXT_NEW_PRODUCT,
    BUTTON_ADD = English?.AddProductModal?.BUTTON_ADD,
    TEXT_NO_MANUFACTURER = English?.AddProductModal?.TEXT_NO_MANUFACTURER,
    TEXT_EXISTING_PRODUCTS = English?.AddProductModal?.TEXT_EXISTING_PRODUCTS,
    BUTTON_VIEW = English?.AddProductModal?.BUTTON_VIEW,
    TEXT_PRODUCTS_ARRAY_TOOLS = English?.AddProductModal?.TEXT_PRODUCTS_ARRAY_TOOLS,
    TEXT_PRODUCTS_ARRAY_MATERIALS = English?.AddProductModal?.TEXT_PRODUCTS_ARRAY_MATERIALS
  } = multiLanguageData?.AddProductModal || {};

  const productTypeOptions = [
    {
      id: 1,
      name: TEXT_PRODUCTS_ARRAY_TOOLS || "Tools",
      value: TEXT_PRODUCTS_ARRAY_TOOLS || "Tools"
    },
    {
      id: 2,
      name: TEXT_PRODUCTS_ARRAY_MATERIALS || "Material",
      value: TEXT_PRODUCTS_ARRAY_MATERIALS || "Material"
    }
  ];

  const manufacturerName = manufacturerSearchTerm.trim();
  const normalizedManufacturerName = manufacturerName.toLowerCase();
  const hasExactManufacturerMatch = manufacturerSuggestions.some(
    (item) => String(item?.name || "").trim().toLowerCase() === normalizedManufacturerName
  );
  const selectedCompanyBlocksPublicSubmission =
    Boolean(selectedManufacturer?.id) && selectedManufacturer?.allowPublicProductSubmission === false;
  const showAddCompanyOption =
    manufacturerName.length > 1 &&
    !selectedManufacturer &&
    !manufacturerSearchLoading &&
    !hasExactManufacturerMatch;
  const isManufacturerLookupActive = manufacturerSearchTerm.trim().length > 1 && !selectedManufacturer;
  const hasSelectedManufacturer = Boolean(selectedManufacturer);

  useEffect(() => {
    if (!open) return;
    setManufacturerPageNumber(1);
    setManufacturerHasMore(true);
    setManufacturerPageLoading(false);
    if (initialProductName) setProductSearchTerm(initialProductName);
    if (initialManufacturerName) {
      setManufacturerSearchTerm(initialManufacturerName);
      setSelectedManufacturer({
        id: 0,
        name: initialManufacturerName,
        manufacturer: false,
        isNew: true
      });
    }
    if (initialProductType) {
      if (initialProductType.toLowerCase().includes("tool")) {
        setProductType(TEXT_PRODUCTS_ARRAY_TOOLS || "Tools");
      } else {
        setProductType(TEXT_PRODUCTS_ARRAY_MATERIALS || "Material");
      }
    }
  }, [open, initialProductName, initialManufacturerName, initialProductType]);

  const getData = async (searchTerm, isProductSearch) => {
    try {
      setIsLoading(true);
      const obj = {
        IncludeRecordNr: true,
        SearchList: isProductSearch ? [{ name: searchTerm }] : [{ manufacturerName: searchTerm }],
        NrOfRecPerPage: 20,
        SortList: [{ FieldName: "Name", Direction: "ASC" }],
        PageNr: 1,
        FullSearch: "",
        TypeOfObjectReturned: "NameOnly"
      };
      const res = await Postrequestcall(FETCH_PRODUCTS, obj, loginData?.accessToken);
      let resData = res?.data?.data ?? [];
      const filteredData = resData.filter((item) => item.manufacturerId === Number(mainId));
      const commonItems = productData.filter((item1) =>
        resData.some((item2) => item2.id === item1.id)
      );
      setProductData(from === "manufacture" ? filteredData : isProductSearch ? resData : commonItems);
    } catch (error) {
      console.log("getData-> Error While Fetching Products: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Search companies/manufacturers using FETCH_COMPANIES_BY_NAME
  const searchManufacturers = async (searchTerm, pageNr = 1, append = false) => {
    if (!searchTerm || searchTerm.trim().length < 1) {
      setManufacturerSuggestions([]);
      setShowManufacturerSuggestions(false);
      setManufacturerHasMore(false);
      return;
    }
    try {
      if (pageNr === 1) {
        setManufacturerSearchLoading(true);
      } else {
        setManufacturerPageLoading(true);
      }
      const obj = {
        PageNr: pageNr,
        NrOfRecPerPage: manufacturerPageSize,
        FullSearch: searchTerm,
        UserId: currentUserId,
        IncludeRecordNr: "true",
        TypeOfObjectReturned: "",
        FetchAllowedRecordsOnly: false,
        SearchList: [{}],
        SortList: [{ FieldName: "Name", Direction: "ASC" }]
      };
      const res = await Postrequestcall(FETCH_COMPANIES_BY_NAME, obj, loginData?.accessToken);
      const suggestions = res?.data?.data ?? [];
      const totalRecords = Number(res?.data?.nrOfRecords ?? res?.data?.RecordNr ?? suggestions.length ?? 0);
      setManufacturerSuggestions((prev) => (append ? [...prev, ...suggestions] : suggestions));
      setShowManufacturerSuggestions((prev) =>
        append ? prev || suggestions.length > 0 : suggestions.length > 0
      );
      setManufacturerHasMore(
        pageNr * manufacturerPageSize < totalRecords || suggestions.length === manufacturerPageSize
      );
    } catch (error) {
      console.log("searchManufacturers-> Error: ", error);
    } finally {
      setManufacturerSearchLoading(false);
      setManufacturerPageLoading(false);
    }
  };

  const handleManufacturerSelect = (manufacturer) => {
    setSelectedManufacturer(manufacturer);
    setManufacturerSearchTerm(manufacturer.name);
    setShowManufacturerSuggestions(false);
    setManufacturerSuggestions([]);
    setManufacturerPageNumber(1);
    setManufacturerHasMore(true);
  };

  const handleAddCompanyAsManufacturer = () => {
    const value = manufacturerSearchTerm.trim();
    if (!value) return;
    setSelectedManufacturer({
      id: 0,
      name: value,
      manufacturer: false,
      isNew: true
    });
    setManufacturerSuggestions([]);
    setShowManufacturerSuggestions(false);
  };

  const handleManufacturerClear = () => {
    setSelectedManufacturer(null);
    setManufacturerSearchTerm("");
    setManufacturerSuggestions([]);
    setShowManufacturerSuggestions(false);
    setManufacturerPageNumber(1);
    setManufacturerHasMore(true);
  };

  const handleUseCurrentCompanyAsManufacturer = () => {
    const companyName = String(currentCompanyName || "").trim();
    const companyId = Number(mainId) || 0;
    if (!companyName || !companyId) return;

    setSelectedManufacturer({
      id: companyId,
      name: companyName,
      manufacturer: false,
      allowPublicProductSubmission: currentCompanyAllowPublicProductSubmission
    });
    setManufacturerSearchTerm(companyName);
    setManufacturerSuggestions([]);
    setShowManufacturerSuggestions(false);
  };

  const handleUseCurrentManufacturer = () => {
    const manufacturerName = String(manufactureDetails?.name || "").trim();
    const manufacturerId = Number(manufactureDetails?.id) || 0;
    if (!manufacturerName || !manufacturerId) return;

    setSelectedManufacturer({
      id: manufacturerId,
      name: manufacturerName,
      manufacturer: true,
      allowPublicProductSubmission: manufactureDetails?.allowPublicProductSubmission
    });
    setManufacturerSearchTerm(manufacturerName);
    setManufacturerSuggestions([]);
    setShowManufacturerSuggestions(false);
  };

  const currentManufacturerActionLabel =
    from === "company"
      ? `Select ${currentCompanyName} as manufacturer`
      : `Select ${manufactureDetails?.name} as manufacturer`;

  const onCheckDisable = () => {
    if (manufacturerSearchTerm.length === 0) {
      return !(productSearchTerm.length > 1 && productType !== "");
    } else {
      return !(
        productSearchTerm.length > 1 &&
        manufacturerSearchTerm.length > 1 &&
        productType !== ""
      );
    }
  };

  const checkProductAlreadyExistInData = async (item) => {
    try {
      let obj = {};
      let url = "";
      if (from === "company" || from ==="manufacturer-company") {
        obj = {
          PageNr: 1,
          NrOfRecPerPage: 20,
          FullSearch: "",
          SearchList: [{ companyId: mainId, productId: item?.id }],
          userId: currentUserId,
          IncludeRecordNr: true,
          SortList: [{}],
          FetchAllowedRecordsOnly: true,
          TypeOfObjectReturned: ""
        };
        url = FETCH_COMPANIES_PRODUCTS;
      } else if (from === "trade") {
        obj = {
          FullSearch: "",
          SearchList: [{ TradeId: mainId, productId: item?.id }],
          userId: Number(currentUserId),
          TypeOfObjectReturned: "",
          FetchAllowedRecordsOnly: true
        };
        url = FETCH_TRADE_PRODUCTS;
      } else if (from === "project") {
        obj = {
          PageNr: 1,
          NrOfRecPerPage: 20,
          FullSearch: "",
          SearchList: [{ projectId: mainId, productId: item?.id }],
          userId: Number(currentUserId),
          IncludeRecordNr: true,
          SortList: [{}],
          TypeOfObjectReturned: "",
          FetchAllowedRecordsOnly: true
        };
        url = FETCH_PROJECTS_PRODUCTS;
      } else if (from === "SiteCard") {
        obj = {
          userId: Number(currentUserId),
          SiteId: mainId,
          PageSize: 20,
          PageNumber: 1
        };
        url = FETCH_PROJECT_SITE_PRODUCTS;
      }
      const res = await Postrequestcall(url, obj, loginData?.accessToken);
      const filteredData = res?.data?.data?.filter((p) => p.productId === Number(item?.id)) ?? [];
      return filteredData?.length === 0 ? false : true;
    } catch (error) {
      console.log("checkProductAlreadyExistInData-> Error: ", error);
      return false;
    }
  };

  const handleAddExistProduct = async (item) => {
    setAddingProductId(item?.id);
    try {
      const productAlreadyExists = await checkProductAlreadyExistInData(item);
      if (productAlreadyExists) {
        alert("Product already added");
        setAddingProductId(null);
        return;
      }
      await saveProduct(item?.id);
      onClose();
    } catch (error) {
      console.log("handleAddExistProduct-> Error: ", error);
      setAddingProductId(null);
    }
  };

  const handleManufacturerScroll = (event) => {
    const target = event.currentTarget;
    const reachedBottom = target.scrollTop + target.clientHeight >= target.scrollHeight - 32;
    if (!showManufacturerSuggestions || !manufacturerHasMore || manufacturerSearchLoading || manufacturerPageLoading) return;
    if (reachedBottom) {
      const nextPage = manufacturerPageNumber + 1;
      setManufacturerPageNumber(nextPage);
      searchManufacturers(manufacturerSearchTerm, nextPage, true);
    }
  };

  const onViewClick = (item) => {
    navigate(`/product/${item?.id}`);
  };

  const getManufacturerId = async (searchTerm) => {
    try {
      if (from === "manufacture" && manufactureDetails?.id && !skipManufacturerPrefill) {
        return manufactureDetails?.id;
      }

      // If user selected a manufacturer/company from suggestions
      if (selectedManufacturer?.id !== undefined && selectedManufacturer?.id !== null) {
        const selectedId = Number(selectedManufacturer?.id);

        if (selectedId === 0) {
          // Brand new manufacturer being created right now (id 0) → call SAVE_COMPANIES
          const saveObject = {
            userId: Number(currentUserId),
            ReturnRecordId: true,
            ReturnRecordError: true,
            SaveList: [
              {
                Id: 0,
                Name: selectedManufacturer?.name || searchTerm,
                ModifiedBy: Number(currentUserId),
                RecordStatusId: 1,
                Manufacturer: true
              }
            ]
          };
          const resData = await Postrequestcall(SAVE_COMPANIES, saveObject, loginData?.accessToken);
          return resData?.data?.data?.[0]?.objData?.id ?? 0;
        }

        // Existing company or manufacturer selected (id > 0) → NEVER call SAVE_COMPANIES to convert
        // Just use the existing id as the ManufacturerId for the product
        return selectedId;
      }

      // Fallback path: user typed a name but didn't pick from the dropdown
      if (searchTerm?.trim() !== "") {
        const obj = {
          PageNr: 1,
          NrOfRecPerPage: 20,
          FullSearch: searchTerm,
          UserId: currentUserId,
          IncludeRecordNr: "true",
          TypeOfObjectReturned: "",
          FetchAllowedRecordsOnly: false,
          SearchList: [{}],
          SortList: [{ FieldName: "Name", Direction: "ASC" }]
        };
        const res = await Postrequestcall(FETCH_COMPANIES_BY_NAME, obj, loginData?.accessToken);
        const suggestions = res?.data?.data ?? [];

        // Try exact match
        const matched = suggestions.find(
          (item) => String(item?.name || "").trim().toLowerCase() === searchTerm.trim().toLowerCase()
        );

        if (matched) {
          // Existing record found → do not auto-convert (only create when id === 0)
          return Number(matched.id);
        }

        // No match at all → this is a brand new manufacturer (id 0) → call SAVE_COMPANIES
        const saveObject = {
          userId: Number(currentUserId),
          ReturnRecordId: true,
          ReturnRecordError: true,
          SaveList: [
            {
              Id: 0,
              Name: searchTerm,
              ModifiedBy: Number(currentUserId),
              RecordStatusId: 1,
              Manufacturer: true
            }
          ]
        };
        const resData = await Postrequestcall(SAVE_COMPANIES, saveObject, loginData?.accessToken);
        return resData?.data?.data?.[0]?.objData?.id ?? 0;
      }

      return 0;
    } catch (error) {
      console.log("getManufacturerId-> Error: ", error);
    }
  };

  const handleAddNewProduct = async () => {
    try {
      setShowSubmitLoading(true);
      let manufacturerId = await getManufacturerId(manufacturerSearchTerm);
      const saveObject = {
        UserId: Number(currentUserId),
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: 0,
            Name: productSearchTerm,
            Info: "",
            RecordStatusId: 1,
            ModifiedBy: Number(currentUserId),
            ManufacturerId: manufacturerId,
            productType: productType
          }
        ]
      };
      let res = await Postrequestcall(SAVE_PRODUCTS, saveObject, loginData?.accessToken);
      if (res?.status === 201) {
        const productId = res?.data?.data?.[0]?.objData?.id;
        const createdProductPayload = {
          productId: productId ?? 0,
          manufacturerId: manufacturerId ?? 0
        };
        let handledProductCreatedCallback = false;
        if (from === "productProfile") {
          navigate(`/product/${productId}`);
        } else if (!skipCompanyProductSave && typeof saveProduct === "function") {
          await saveProduct(productId ?? 0,manufacturerId );
        } else if (typeof onProductCreated === "function") {
          await onProductCreated(createdProductPayload);
          handledProductCreatedCallback = true;
        }
        if (!handledProductCreatedCallback && typeof onProductCreated === "function") {
          await onProductCreated(createdProductPayload);
        }
        onClose();
      } else {
        let alertObj = {
          showAlert: true,
          text: "Duplicate Entry",
          text2: res?.data?.data[0]?.message || "Product already exists"
        };
        dispatch(setShowalert(alertObj));
      }
    } catch (error) {
      console.log("handleAddNewProduct-> Error: ", error);
    } finally {
      setShowSubmitLoading(false);
    }
  };

  return (
    <Modal open={open}>
      <Box
        className="user-modal-responsive"
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "92vw", sm: 520 },
          bgcolor: "background.paper",
          borderRadius: 3,
          boxShadow: "0 24px 60px rgba(0,0,0,0.18)",
          p: 3,
          maxHeight: "90vh",
          overflow: "visible",
          display: "flex",
          flexDirection: "column"
        }}>
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2
          }}>
          <Typography variant="h6" sx={{ fontWeight: 700, fontSize: "1.1rem" }}>
            {title}
          </Typography>
          <IconButton
            onClick={() => onClose()}
            size="small"
            sx={{
              bgcolor: "grey.100",
              "&:hover": { bgcolor: "grey.200" }
            }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        <Stack spacing={2} sx={{ flex: 1, overflow: "visible", minHeight: 0 }}>
          {/* Product Name Search */}
          <Box>
            <Typography
              variant="caption"
              
              sx={{color: "text.secondary", 
                mb: 0.35,
                display: "block",
                fontWeight: 600,
                textTransform: "uppercase",
                letterSpacing: 0.5,
                fontSize: "0.72rem"
              }}>
              Product Name
            </Typography>
            <SearchField
              size="small"
              value={productSearchTerm}
              onChange={(value) => {
                setIsLoading(true);
                const searchValue = value;
                setProductSearchTerm(searchValue);
                if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
                debounceTimeout.current = setTimeout(() => {
                  getData(value, true);
                }, 1000);
              }}
              onSubmit={() => {
                setProductSearchTerm(productSearchTerm);
                getData(productSearchTerm, true);
              }}
              placeholder={TEXT_PRODUCT_NAME}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2
                },
                "& .MuiInputBase-input": {
                  py: 1
                }
              }}
            />
          </Box>

          {/* Manufacturer Field */}
          {from === "manufacture" && manufactureDetails?.name && lockManufacturerToCurrent ? (
            <Box>
              <Typography variant="caption"  sx={{color: "text.secondary",  mb: 0.5, display: "block", fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5 }}>
                Manufacturer
              </Typography>
              <TextField
                variant="outlined"
                value={manufactureDetails?.name}
                fullWidth
                size="small"
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <BusinessIcon fontSize="small" color="action" />
                      </InputAdornment>
                    )
                  }
                }}
                disabled
              sx={{
                "& .MuiOutlinedInput-root": {
                  bgcolor: "grey.50",
                  borderRadius: 2
                }
              }}
            />
              {showCurrentManufacturerAction && (
                <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 0.75 }}>
                  <Button
                    variant="text"
                    size="small"
                    onClick={handleUseCurrentManufacturer}
                    sx={{
                      px: 0,
                      textTransform: "none",
                      fontWeight: 700
                    }}>
                    {currentManufacturerActionLabel}
                  </Button>
                </Box>
              )}
            </Box>
          ) : (
            <Box sx={{ position: "relative" }}>
              <Typography variant="caption"  sx={{color: "text.secondary",  mb: 0.5, display: "block", fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5 }}>
                Manufacturer (Optional)
              </Typography>

              {selectedManufacturer ? (
                <>
                {/* Selected manufacturer chip */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    p: 1.5,
                    border: "1px solid",
                    borderColor: "primary.main",
                    borderRadius: 2,
                    bgcolor: "primary.50"
                  }}>
                  <Avatar sx={{ width: 28, height: 28, bgcolor: "primary.main", fontSize: "0.75rem" }}>
                    {selectedManufacturer.name?.[0]?.toUpperCase()}
                  </Avatar>
                  <Stack flex={1} spacing={0} sx={{ minWidth: 0 }}>
                    <Typography variant="body2" sx={{ fontWeight: 600 }} noWrap>{selectedManufacturer.name}</Typography>
                    {selectedManufacturer.city && (
                      <Typography variant="caption" sx={{ color: "text.secondary" }}>{selectedManufacturer.city}</Typography>
                    )}
                  </Stack>
                   <IconButton size="small" onClick={handleManufacturerClear}>
                     <CloseIcon fontSize="small" />
                   </IconButton>
                 </Box>
                 {selectedCompanyBlocksPublicSubmission && (
                   <Alert severity="error" variant="outlined" sx={{ mt: 1.25, mb: 1.5, borderRadius: 2 }}>
                     Product public submission is disabled by the admin of the manufacturer.
                   </Alert>
                 )}
                 </>
              ) : (
                <>
                  <TextField
                    fullWidth
                    size="small"
                    value={manufacturerSearchTerm}
                      onChange={(e) => {
                      const value = e.target.value;
                      setManufacturerSearchTerm(value);
                      setSelectedManufacturer(null);
                      setManufacturerPageNumber(1);
                      setManufacturerHasMore(true);
                      if (manufacturerDebounceTimeout.current) {
                        clearTimeout(manufacturerDebounceTimeout.current);
                      }
                      manufacturerDebounceTimeout.current = setTimeout(() => {
                        searchManufacturers(value, 1, false);
                      }, 400);
                    }}
                    placeholder={TEXT_MANUFRACTURER_OPTIONAL || "Search manufacturer..."}
                    variant="outlined"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          {manufacturerSearchLoading ? (
                            <CircularProgress size={16} />
                          ) : (
                            <SearchIcon fontSize="small" color="action" />
                          )}
                        </InputAdornment>
                      )
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": { borderRadius: 2 }
                    }}
                  />

                  {((from === "company" && currentCompanyName) ||
                    (from === "manufacturer-company" && manufactureDetails?.name) ||
                    (from === "manufacture" && manufactureDetails?.name)) &&
                    !selectedManufacturer &&
                    showCurrentManufacturerAction && (
                    <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 0.75 }}>
                      <Button
                        variant="text"
                        size="small"
                        onClick={
                          from === "company"
                            ? handleUseCurrentCompanyAsManufacturer
                            : handleUseCurrentManufacturer
                        }
                        sx={{
                          px: 0,
                          textTransform: "none",
                          fontWeight: 700
                        }}>
                        {currentManufacturerActionLabel}
                      </Button>
                    </Box>
                  )}

                  {/* Manufacturer Suggestions Dropdown */}
                  {(showManufacturerSuggestions ||
                    (showAddCompanyOption && manufacturerName.length > 1)) && (
                    <Fade in>
                      <Paper
                        elevation={8}
                        onScroll={handleManufacturerScroll}
                        sx={{
                          position: "absolute",
                          top: "100%",
                          left: 0,
                          right: 0,
                          zIndex: 3000,
                          maxHeight: "35vh",
                          overflow: "auto",
                          overflowY: "auto",
                          borderRadius: 2,
                          mt: 0.5,
                          border: "1px solid",
                          borderColor: "grey.200",
                          WebkitOverflowScrolling: "touch"
                        }}>
                        {showAddCompanyOption && (
                          <Box
                            onClick={handleAddCompanyAsManufacturer}
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 0.4,
                              px: 2,
                              py: 1.4,
                              cursor: "pointer",
                              borderBottom: "1px solid",
                              borderColor: "grey.100",
                              "&:hover": { bgcolor: "primary.50" }
                            }}>
                            <Typography variant="body2" sx={{ fontWeight: 700 }}>
                              {`Create new manufacturer: ${manufacturerSearchTerm.trim()}`}
                            </Typography>
                            <Typography variant="caption" sx={{ color: "text.secondary" }}>
                              {`This will create a new manufacturer with the name "${manufacturerSearchTerm.trim()}"`}
                            </Typography>
                          </Box>
                        )}
                        {manufacturerSuggestions.length > 0 ? (
                          manufacturerSuggestions.map((mfr, idx) => (
                            <Box
                              key={mfr.id || idx}
                              onClick={() => handleManufacturerSelect(mfr)}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1.5,
                                px: 2,
                                py: 1.2,
                                cursor: "pointer",
                                borderBottom:
                                  idx < manufacturerSuggestions.length - 1 ? "1px solid" : "none",
                                borderColor: "grey.100",
                                "&:hover": { bgcolor: "primary.50" },
                                transition: "background 0.15s"
                              }}>
                              <Avatar
                                src={mfr.logo || mfr.imageUrl}
                                sx={{ width: 30, height: 30, bgcolor: "primary.main", fontSize: "0.75rem" }}>
                                {mfr.name?.[0]?.toUpperCase()}
                              </Avatar>
                              <Stack flex={1} spacing={0} sx={{ minWidth: 0 }}>
                                <Typography sx={{ fontWeight: 600, whiteSpace: "normal", wordBreak: "break-word", WebkitLineClamp: 2, display: "-webkit-box", WebkitBoxOrient: "vertical", overflow: "hidden" }} variant="body2">
                                  {mfr.name}
                                </Typography>
                                {(mfr.city || mfr.country) && (
                                  <Typography variant="caption" sx={{ color: "text.secondary" }}>
                                    {[mfr.city, mfr.country].filter(Boolean).join(", ")}
                                  </Typography>
                                )}
                              </Stack>
                              <Chip
                                label={mfr.manufacturer ? "Manufacturer" : "Company"}
                                size="small"
                                color={mfr.manufacturer ? "primary" : "secondary"}
                                variant="outlined"
                                sx={{ fontSize: "0.6rem" }}
                              />
                            </Box>
                          ))
                        ) : !showAddCompanyOption ? null : null}
                      </Paper>
                    </Fade>
                  )}
                </>
              )}
            </Box>
          )}

          {/* Product Type */}
          <Box
            sx={{
              // mb: 4.25,
              position: "relative",
              zIndex: 2,
              bgcolor: "background.paper"
            }}>
            <Typography variant="caption"  sx={{color: "text.secondary",  mb: 0.5, display: "block", fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5 }}>
              Type
            </Typography>
            <FormControl fullWidth size="small">
              <Select
                value={productType}
                displayEmpty
                renderValue={(val) => {
                  const selectedType = productTypeOptions.find((type) => type.value === val);
                  return selectedType?.name || (
                    <Typography sx={{ color: "text.secondary" }}>{TEXT_TYPE || "Select type..."}</Typography>
                  );
                }}
                onChange={(e) => setProductType(e.target.value)}
                sx={{
                  borderRadius: 2,
                  minHeight: 48,
                  "& .MuiSelect-select": {
                    display: "flex",
                    alignItems: "center",
                    py: 1.25
                  }
                }}>
                {productTypeOptions?.map((type, i) => (
                  <MenuItem value={type?.value} key={type?.id || i}>
                    {type?.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Stack>

        {/* Results Area */}
        <Box
          sx={{
            mt: hasSelectedManufacturer ? 10 : 6.5,
            pt: hasSelectedManufacturer ? 3.5 : 3,
            borderTop: "1px solid",
            borderColor: "grey.200",
            position: "relative",
            zIndex: 1,
            bgcolor: "background.paper",
            height: hasSelectedManufacturer ? 320 : 280,
            overflow: "auto",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": { display: "none" }
          }}>
          {isLoading && productSearchTerm?.length > 1 ? (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
              <Loader />
            </Box>
          ) : (
            <>
              {(productSearchTerm?.length > 1 || manufacturerSearchTerm?.length > 1) && (
                <Stack spacing={1.5}>
                  {/* New Product Section */}
                  <Box>
                    <Typography
                      variant="caption"
                      
                      sx={{color: "text.secondary", 
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                        mb: 0.75,
                        fontWeight: 700,
                        textTransform: "uppercase",
                        letterSpacing: 0.5,
                        fontSize: "0.72rem"
                      }}>
                      <AddIcon sx={{ fontSize: 14 }} />
                      {TEXT_NEW_PRODUCT || "Create New"}
                    </Typography>
                    <Card
                      variant="outlined"
                      sx={{
                        borderRadius: 2,
                        borderStyle: "dashed",
                        borderColor: "primary.light",
                        bgcolor: "primary.50",
                        px: 0.5,
                        py: 0.25,
                        "&:hover": { borderColor: "primary.main", bgcolor: "primary.100" },
                        transition: "all 0.2s"
                      }}>
                      <ListItem sx={{ py: 0.75, px: 1, borderRadius: 2, textTransform: "none" }} secondaryAction={ <Button loading={showSubmitLoading} color="primary" variant="contained" size="small" onClick={handleAddNewProduct} disabled={onCheckDisable() || selectedCompanyBlocksPublicSubmission}>
                            {BUTTON_ADD || "Add"}
                          </Button>
                        }>
                        <ListItemText sx={{ fontWeight: 600, lineHeight: 1.1, fontSize: "0.92rem" }} primary={ <Typography variant="body2">
                              {productSearchTerm || "—"}
                            </Typography>
                          }
                          secondary={
                            from === "manufacture" && manufactureDetails?.name
                              ? ""
                              : selectedManufacturer
                              ? selectedManufacturer.name
                              : manufacturerSearchTerm
                              ? manufacturerSearchTerm
                              : TEXT_NO_MANUFACTURER || "No manufacturer"
                          }
                        />
                      </ListItem>
                    </Card>
                  </Box>

                  {/* Existing Products */}
                  {productData?.length > 0 && (
                    <Box>
                      <Divider sx={{ mb: 1.5 }} />
                      <Typography
                        variant="caption"
                        
                        sx={{color: "text.secondary", 
                          display: "block",
                          mb: 1,
                          fontWeight: 700,
                          textTransform: "uppercase",
                          letterSpacing: 0.5
                        }}>
                        {TEXT_EXISTING_PRODUCTS || "Existing Products"}
                      </Typography>
                      <List disablePadding>
                        <Stack sx={{ gap: 1 }} >
                          {productData?.map((item, index) => (
                            <Card
                              key={index.toString()}
                              variant="outlined"
                              sx={{
                                borderRadius: 2,
                                "&:hover": { borderColor: "primary.main", boxShadow: "0 2px 8px rgba(0,0,0,0.08)" },
                                transition: "all 0.2s"
                              }}>
            <ListItem
secondaryAction={
                <Button
                  loading={addingProductId === item?.id}
                  color="primary"
                  variant="outlined"
                  size="small"
                  startIcon={
                    from === "productProfile" || (from === "manufacture" && manufactureDetails?.name)
                      ? <ViewIcon />
                      : <AddIcon />
                  }
                  onClick={() => {
                    from === "productProfile" ||
                    (from === "manufacture" && manufactureDetails?.name)
                      ? onViewClick(item)
                      : handleAddExistProduct(item);
                  }}
                  disabled={addingProductId === item?.id}
                  sx={{ borderRadius: 2, textTransform: "none" }}>
                  {from === "productProfile" || (from === "manufacture" && manufactureDetails?.name)
                    ? BUTTON_VIEW || "View"
                    : BUTTON_ADD || "Add"}
                </Button>
              }>
                                <ListItemText
                                  primary={
                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                      {item?.name}
                                    </Typography>
                                  }
                                  secondary={
                                    from === "manufacture" && manufactureDetails?.name
                                      ? ""
                                      : item?.manufacturerName
                                  }
                                />
                              </ListItem>
                            </Card>
                          ))}
                        </Stack>
                      </List>
                      {manufacturerPageLoading && (
                        <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
                          <Loader />
                        </Box>
                      )}
                    </Box>
                  )}
                </Stack>
              )}

              {productSearchTerm.length === 0 && manufacturerSearchTerm.length === 0 && (
                <Box
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 1,
                    opacity: 0.5
                  }}>
                  <SearchIcon sx={{ fontSize: 40, color: "text.disabled" }} />
                  <Typography variant="body2" sx={{ color: "text.secondary" }} textAlign="center">
                    Search for a product name to get started
                  </Typography>
                </Box>
              )}
            </>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default AddProductModal;

